export default __webpack_public_path__ + "static/media/332.c253825b.png";